import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import CardLoading from "../../Components/CardLoading/CardLoading";
import Message from "../../Components/Message";
import ProjectCard from "./ProjectCard/ProjectCard";
import './Projects.scss';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]=useState('')
  const [active, setActive] = useState("ALL")
  
  const tech = [
    "ALL",
    "Production",
    "LANDING-PAGE",
    "REACT",
    "TYPESCRIPT",
    "FULL-STACK",
    "FIREBASE",
    "NODEJS",
    "NEXTJS",
  ];
  useEffect(() => {
    setIsLoading(true)
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch((error) => setError(error));
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
  }, [active]);  
  
  const activator = (item) => {
    setActive(item)
  }
  const filterItems = projects?.filter((project) =>
    project?.categroy?.includes(`${active}`)
  );
  let content = null;
  if (isLoading) {
    content = (
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-x-8 md:gap-x-4 gap-y-2 lg:gap-y-7 md:gap-y-3 2xl:grid-cols-4">
        <CardLoading />
        <CardLoading />
        <CardLoading />
        <CardLoading />
        <CardLoading />
        <CardLoading />
        <CardLoading />
        <CardLoading />
      </div>
    );
  } else if (!isLoading && error) {
    content = (
      <div className=" min-h-300 flex items-center text-center justify-center">
        <Message
          message="There was server side error!"
          color="gray"
          deep="50"
        />
      </div>
    );
  } else if (!isLoading && error && projects.length === 0) {
    content = (
      <div className=" min-h-300 flex items-center text-center justify-center">
        <Message message="Project not found!" color="green" deep="600" />
      </div>
    );
  } else if (!isLoading && !error && projects.length === 0) {
    content = (
      <div className=" min-h-300 flex items-center text-center justify-center text-gray-50">
        <Message message="Project not found!" color="gray" deep="50" />
      </div>
    );
  }  else if (!isLoading && !error && projects?.length > 0) {
    if (active === "ALL") {
      content = content = (
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-x-8 md:gap-x-4 gap-y-2 lg:gap-y-7 md:gap-y-3 2xl:grid-cols-4">
          {projects.map((project) => (
            <ProjectCard key={project._id} project={project} />
          ))}
        </div>
      );
    } else {
      
      if (filterItems.length === 0) {
        content = (
          <Message message="No Project found!" color="gray" deep="50" />
        );
      } else {
        content = (
          <div className="grid 2xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 lg:gap-x-8 md:gap-x-4 gap-y-2 lg:gap-y-7 md:gap-y-3">
            {filterItems.map((project) => (
              <ProjectCard key={project._id} project={project} />
            ))}
          </div>
        );
      }
    }
  }


  return (
    <div
      className="min-h-screen min-w-screen projects py-20
    "
    >
      <div className="flex item-center justify-center font-extrabold text-7xl p-10">
        <h1 className="animate-charcter ">PROJECTS</h1>
      </div>
      <div className="flex flex-col  items-center min-h-screen m-auto  gap-10 ">
        {/* BUTTON START */}
        <div className="space-x-2 space-y-2 mx-5">
          {tech.map((item, index) => (
            <button
              onClick={() => activator(item)}
              key={index}
              className={`ring-1 px-3 py-2  font-bold hover:bg-emerald-700 rounded-sm ${
                active === item ? "bg-emerald-700" : "bg-transparent"
              }`}
            >
              {item.toLocaleUpperCase()}
            </button>
          ))}
        </div>
        {/* BUTTON END */}
        {content}
      </div>
    </div>
  );
};

export default Projects;
